var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTerminAuswhlen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B71E3F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.8,16.1H116V3.2h-12.9v32.2H90.2V16.1H51.5V3.2H38.7v32.2H25.8V16.1H12.9C5.8,16.1,0,21.9,0,29v96.6 c0,7.1,5.8,12.9,12.9,12.9h116c7.1,0,12.9-5.8,12.9-12.9V29C141.7,21.9,136,16.1,128.8,16.1z M45.1,119.2H19.3V93.4h25.8V119.2z  M45.1,80.5H19.3V54.8h25.8V80.5z M83.8,119.2H58V93.4h25.8V119.2z M83.8,80.5H58V54.8h25.8V80.5z M122.4,80.5H96.6V54.8h25.8V80.5z "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTerminAuswhlen);
export default __webpack_public_path__ + "static/media/icon-termin-auswählen.ea49673d06ca2245045348a6d71962bd.svg";
export { ForwardRef as ReactComponent };